import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetAmountRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetAmountResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setAmount = (request: SetAmountRequest, options?: CashRequestOptions) =>
  post<SetAmountRequest, SetAmountResponse>('/2.0/cash/set-amount', request, { ...options, rejectOnError: true })
